import * as React from "react";
import cx from "clsx";
import CheckCircle from "../../../icons/CheckCircle";
import Circle from "../../../icons/CircleEmpty";
import AlertCircle from "../../../icons/AlertCircle";
import CloseCircle from "../../../icons/CloseCircle";
const getTypeIcon = ({
  type,
  active
}) => {
  if (type === "success" && active) return /*#__PURE__*/React.createElement("svg", {
    height: "16",
    width: "16",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "green",
    strokeWidth: "1px",
    cx: "8",
    cy: "8",
    r: "6"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "green",
    stroke: "none",
    cx: "8",
    cy: "8",
    r: "3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "2.5s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: "0.1"
  })));
  if (type === "success") return /*#__PURE__*/React.createElement(CheckCircle, {
    color: "success",
    size: "small"
  });
  if (type === "warning") return /*#__PURE__*/React.createElement(AlertCircle, {
    color: "warning",
    size: "small"
  });
  if (type === "critical") return /*#__PURE__*/React.createElement(CloseCircle, {
    color: "critical",
    size: "small"
  });
  return /*#__PURE__*/React.createElement(Circle, {
    color: "tertiary",
    size: "small"
  });
};
const getBackgroundClassName = type => {
  const classNames = {
    success: "bg-green-normal",
    warning: "bg-orange-normal",
    critical: "bg-red-normal",
    info: "bg-blue-normal"
  };
  return classNames[type];
};
const TypeIcon = ({
  type,
  active,
  mobile
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: cx("z-default h-icon-medium relative flex items-center justify-center", mobile && "min-w-lg")
  }, getTypeIcon({
    type,
    active
  }), /*#__PURE__*/React.createElement("div", {
    className: cx("size-icon-medium absolute top-0 rounded-full opacity-10", mobile ? "left-xxxs" : "-left-xxxs", type && getBackgroundClassName(type), active && "animate-[pulse-zero_2.5s_ease-in-out_infinite]")
  }));
};
export default TypeIcon;